import { render, staticRenderFns } from "./yinsi.vue?vue&type=template&id=a8f45460&scoped=true"
import script from "./yinsi.vue?vue&type=script&lang=js"
export * from "./yinsi.vue?vue&type=script&lang=js"
import style0 from "./yinsi.vue?vue&type=style&index=0&id=a8f45460&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f45460",
  null
  
)

export default component.exports